import { useNavState } from '@/providers/NavStateProvider';
import React, { useEffect } from 'react';
import { useLoading } from '@/providers/LoadingProvider';
import { useCurrentWorkspace } from '@/providers/WorkspaceProvider';
import { useCreateBoardSetting } from '@/hooks/api/2480_create_board_setting';
import { useWorkspaceInvalidate } from '@/hooks/api/0101_workspace';
import { toastApiError, toastSuccess } from '@/lib/toast';
import { Link, useNavigate } from 'react-router-dom';
import { SubmitHandler, useForm } from 'react-hook-form';
import { MenuButtonGroup } from '@/components/features/SettingMenuButtonGroup';
import { WorkspaceLayout } from '@/components/layout/WorkspaceLayout';
import { FormGroup } from '@/components/element/Form/FormGroup';

type FormInputs = {
  identifier: string;
  api_key: string;
  api_token: string;
};

export const BoardConnectNew = () => {
  const { setTitle, setBreadcrumbs } = useNavState();
  useEffect(() => setTitle('新規board接続'), []);
  useEffect(() => setBreadcrumbs([{ label: `外部サービス連携`, path: `/w/${_w_!.identifier}/setting/connect` }]), []);

  const navigate = useNavigate();
  const { setShowLoading } = useLoading();
  const { _w_, me } = useCurrentWorkspace();
  const { mutate, data, isPending, error } = useCreateBoardSetting();
  const { invalidate: invalidateWorkspace } = useWorkspaceInvalidate(_w_!.identifier);
  const {
    register,
    handleSubmit,
    setValue,
    getValues,
    resetField,
    formState: { errors },
  } = useForm<FormInputs>({
    mode: 'onBlur',
    criteriaMode: 'all',
    defaultValues: { identifier: _w_!.identifier },
  });

  useEffect(() => setShowLoading(isPending), [isPending]);
  useEffect(() => toastApiError(error), [error]);

  useEffect(() => {
    if (data) {
      invalidateWorkspace();
      toastSuccess('board連携が完了しました');
      navigate(`/w/${_w_!.identifier}/setting/connect`);
    }
  }, [data]);

  const onSubmit: SubmitHandler<FormInputs> = (data) => {
    setShowLoading(true);
    mutate(data);
  };

  return (
    <WorkspaceLayout>
      <div className="container-fluid py-4">
        <MenuButtonGroup selected={'connect'} />

        <div className="row">
          <div className="col-12 col-lg-9 mx-auto">
            <div className="card mb-4" id="basic-info">
              <div className="card-header d-flex align-items-center">
                <div className="col-md-8">
                  <h5 className="mb-0">新規board接続</h5>
                </div>
              </div>

              <form onSubmit={handleSubmit(onSubmit)}>
                <div className="card-body pt-0">
                  <div className="col-md-12">
                    <FormGroup label={'APIキー'} required={true}>
                      <input
                        type="text"
                        className={`form-control ${errors.api_key && 'is-invalid'}`}
                        {...register('api_key', { required: '入力して下さい。' })}
                      />
                      {errors.api_key && <div className="text-xs text-danger mt-1">{errors.api_key.message}</div>}
                    </FormGroup>
                  </div>

                  <div className="col-md-12">
                    <FormGroup label={'APIトークン'} required={true}>
                      <input
                        type="text"
                        className={`form-control ${errors.api_token && 'is-invalid'}`}
                        {...register('api_token', { required: '入力して下さい。' })}
                      />
                      {errors.api_token && <div className="text-xs text-danger mt-1">{errors.api_token.message}</div>}
                    </FormGroup>
                  </div>
                </div>

                <div className="card-footer d-flex align-items-center justify-content-end pt-0">
                  <Link to="" className="btn btn-outline-secondary me-2" onClick={() => navigate(-1)}>
                    戻る
                  </Link>
                  <button type="submit" className="btn bg-gradient-dark btn-icon">
                    <i className="fas fa-check-circle"></i>連携する
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </WorkspaceLayout>
  );
};
